import axios from './_nestAxios'

export const sireventasGetToken = () => axios.get('/asientos-contables/sireventas/obtener-token')
export const descargarPropuesta = data =>
  axios.get('/asientos-contables/sireventas/descargar-propuesta', { params: data })
export const consultarTicket = data => axios.get('/asientos-contables/sireventas/consultar-ticket', { params: data })
export const descargarArchivo = data => axios.get('/asientos-contables/sireventas/descargar-archivo', { params: data })

export const sireValidarCredenciales = () =>
  axios.get('/asientos-contables/sireventas/validar-credenciales')

export const sireObtenerPaginado = data =>
  axios.get('/asientos-contables/sireventas/obtener-paginado', { params: data })
export const sireObtenerExcelComparacionSunat = data =>
  axios.get('/asientos-contables/sireventas/obtener-excelcomparacion', { params: data, responseType: 'blob' })

export const getAsEdicion = _id => axios.get(`/asientos-contables/${_id}`)
export const getAsEdicion2 = _id =>
  axios.get(`/asientos-contables/${_id}`, {
    params: { tipoConsulta: 'edicion-2' }
  })

export const validarPasswordVistaAdmin = data =>
  axios.get('/asientos-contables/validar-password-admin', { params: data })

export const verificarAsientosKardex = () => axios.get('/asientos-contables/verificar-asientos-kardex')

export const validarInventariosxId = _id => axios.get(`/asientos-contables/validar-inventarios/${_id}`)

export const obtenerVentasDetraccion = params => axios.get('/asientos-contables/ventas-detraccion', { params })

export const obtenerInfoNoDomiciliadoxIdAsientoContable = idAsientoContable =>
  axios.get('/asientos-contables/info-no-domiciliado', {
    params: { idAsientoContable }
  })

export const getAsDetalle = (_id, flagSoloMonedaNacional) =>
  axios.get(`/asientos-contables/${_id}`, {
    params: { tipoConsulta: 'detalles', flagSoloMonedaNacional }
  })

export const obtenerGuiasPendientesxIdSocio = idSocio =>
  axios.get('/asientos-contables/guias-pendientes', {
    params: { idSocio: idSocio }
  })

export const getPendientesxSocioxOrigen = (idSocio, origen) =>
  axios.get('/asientos-contables/pendientes', {
    params: { idSocio: idSocio, origen: origen }
  })

export const getPendientesxSocioxTipoSocio = (idSocio, tipoSocio) =>
  axios.get('/asientos-contables/pendientes', {
    params: { idSocio: idSocio, tipoSocio: tipoSocio }
  })

export const imprimirPdfTicketCobranzas = _id =>
  axios.get(`/asientos-contables/descargar/${_id}/cobranzas`, { responseType: 'blob' })

export const imprimirReporteAsientoContable = _id =>
  axios.get(`/asientos-contables/descargar/${_id}/asiento`, { responseType: 'blob' })

export const getAsientoContable_AsientosRelacionados = _id =>
  axios.get(`/asientos-contables/${_id}/asientos-relacionados`)

export const obtenerSiguienteCorrelativoOrigenCanje = () =>
  axios.get('/asientos-contables/siguiente-correlativo-origen-canje')

export const obtenerLetrasPendientesxSemana = () => axios.get('/asientos-contables/letras-pendientes-x-semana')

export const obtenerDetallesTcDiferentexMes = mes =>
  axios.get('/asientos-contables/detalles-tc-diferente', {
    params: { mes }
  })

export const obtenerCuentasUtilizadasxFiltros = (idSocio, tipoDocumentoCuenta) =>
  axios.get('/asientos-contables/cuentas-utlizadas-x-filtros', {
    params: { idSocio, tipoDocumentoCuenta }
  })

export const obtenerDocumentosTipo91xIdSocio = idSocio =>
  axios.get('/asientos-contables/tipo-91', { params: { idSocio } })

export const obtenerDetallexIdAsInfoCuenta = id =>
  axios.get(`/asientos-contables/detalles/${id}`, { params: { tipoConsulta: 'info-cuenta' } })

export const obtenerDetallexIdAsInfoMonedaMonto = id =>
  axios.get(`/asientos-contables/detalles/${id}`, { params: { tipoConsulta: 'info-moneda-monto' } })

export const obtenerDetallexIdAsInfoCentroCosto = id =>
  axios.get(`/asientos-contables/detalles/${id}`, { params: { tipoConsulta: 'info-centro-costo' } })

export const insertarInfoNoDomiciliado = (idAsientoContable, data) =>
  axios.post(`/asientos-contables/${idAsientoContable}/info-no-domiciliado`, data)

export const nuevoAsientoContable = data => axios.post('/asientos-contables/', data)

export const preValidacionNuevo = data => axios.post('/asientos-contables/pre-nuevo', data)

export const nuevoAsientoContable2 = data => axios.post('/asientos-contables/2', data)

export const nuevoAsientoContable4 = data => axios.post('/asientos-contables/4', data)

export const corregirDuplicados = data => axios.post('/asientos-contables/corregir-duplicados', data)

export const nuevoAsientoContableOgDiarioAplicacionNota = data =>
  axios.post('/asientos-contables/og-diario-aplicacion-nota', data)

export const nuevoAsientoContableOgCanje = data => axios.post('/asientos-contables/og-canje', data)

export const importarRegistroCompras = data => axios.post('/asientos-contables/importar/registro-compras', data)

export const importarRegistroVentas = data => axios.post('/asientos-contables/importar/registro-ventas', data)

export const importarCargaDiario = data =>
  axios.post('/asientos-contables/importar/carga-diario', data, { responseType: 'blob' })

export const actualizarAsientoContable = (_id, data) => axios.put(`/asientos-contables/${_id}`, data)

export const eliminarAsientoContable = _id => axios.delete(`/asientos-contables/${_id}`)

export const convertirTxtaExcel = data => axios.post('/asientos-contables/convertirtxt', data, { responseType: 'blob' })

export const buscarExistentePorSerieNumero = ({ origen, idSocio, serieDocumento, numeroDocumento, tipoDocumento }) =>
  axios.get('/asientos-contables/buscar-existente', {
    params: { origen, idSocio, serieDocumento, numeroDocumento, tipoDocumento }
  })

export const descargaPlantillaRegistroCompras = () =>
  axios.get('/asientos-contables/descargar/plantilla/registro-compras', {
    responseType: 'blob'
  })

export const descargaPlantillaImportarPresupuesto = () =>
  axios.get('/asientos-contables/presupuesto/descargar/plantilla', {
    responseType: 'blob'
  })

export const importarPresupuesto = data => axios.post('/asientos-contables/importar/presupuesto', data)

export const consultaGeneralDocumentos = data => axios.get('/asientos-contables/consulta-documentos', { params: data })

export const consultaGeneralCuentasCorrientes = data =>
  axios.get('/asientos-contables/consulta-cuentas-corrientes', { params: data })

export const descargaPlantillaRegistroVentas = () =>
  axios.get('/asientos-contables/descargar/plantilla/registro-ventas', {
    responseType: 'blob'
  })

export const descargaPlantillaImportacionCargaDiario = () =>
  axios.get('/asientos-contables/descargar/plantilla/carga-diario', {
    responseType: 'blob'
  })

export const descargarRegistroCompras = params =>
  axios.get('/asientos-contables/descargar/registro-compras', {
    responseType: 'blob',
    params: params
  })

export const descargarRegistroVentas = params =>
  axios.get('/asientos-contables/descargar/registro-ventas', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteDiario = params =>
  axios.get('/asientos-contables/descargar/reporte-diario', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteDiarioSimplificado = params =>
  axios.get('/asientos-contables/descargar/reporte-diario', {
    responseType: 'blob',
    params: { ...params, tipoConsulta: 'simplificado' }
  })

export const descargarReporteDiarioResumen = params =>
  axios.get('/asientos-contables/descargar/reporte-diario', {
    responseType: 'blob',
    params: { ...params, tipoConsulta: 'resumen' }
  })

export const descargarReporteLibroMayor = params =>
  axios.get('/asientos-contables/descargar/reporte-libro-mayor', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteResumenDelMayor = params =>
  axios.get('/asientos-contables/descargar/reporte-resumen-del-mayor', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteListaOperaciones = params =>
  axios.get('/asientos-contables/descargar/reporte-lista-operaciones', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteListaOperacionesDescuadradas = params =>
  axios.get('/asientos-contables/descargar/reporte-lista-operaciones', {
    responseType: 'blob',
    params: { ...params, tipoConsulta: 'descuadradas' }
  })

export const descargarBalanceCuadre = params =>
  axios.get('/asientos-contables/descargar/balance-cuadre', {
    responseType: 'blob',
    params: params
  })

export const descargarBalanceGeneral = params =>
  axios.get('/asientos-contables/descargar/balance-general', {
    responseType: 'blob',
    params: params
  })

export const descargarFlujoEfectivo = params =>
  axios.get('/asientos-contables/descargar/reporte-flujo-efectivo', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteHistorialCuentasCorrientes = params =>
  axios.get('/asientos-contables/descargar/reporte-historial-cuentas-corrientes', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteEntregas = ({ _idSocio, _idPartida }) =>
  axios.get('/asientos-contables/descargar/reporte-entregas', {
    responseType: 'blob',
    params: { idSocio: _idSocio, idPartida: _idPartida }
  })

export const descargarReporteEntregaARendirxIdTrabajadorViatico = idTrabajadorViatico =>
  axios.get('/asientos-contables/descargar/reporte-entrega-a-rendir', {
    params: { idTrabajadorViatico },
    responseType: 'blob'
  })

export const descargarLibroElectronicoCajaBancos = params =>
  axios.get('/asientos-contables/descargar/libro-electronico/caja-bancos', {
    responseType: 'blob',
    params: params
  })

export const descargarLibroElectronicoRegistroCompras = params =>
  axios.get('/asientos-contables/descargar/libro-electronico/registro-compras', {
    responseType: 'blob',
    params: params
  })

export const descargarLibroElectronicoRVIE = params =>
  axios.get('/asientos-contables/descargar/libro-electronico/rvie', {
    responseType: 'blob',
    params: params
  })

export const descargarLibroElectronicoRegistroVentas = params =>
  axios.get('/asientos-contables/descargar/libro-electronico/registro-ventas', {
    responseType: 'blob',
    params: params
  })

export const descargarLibroElectronicoLibroDiario = params =>
  axios.get('/asientos-contables/descargar/libro-electronico/libro-diario', {
    responseType: 'blob',
    params: params
  })

export const descargarLibroElectronicoLibroMayor = params =>
  axios.get('/asientos-contables/descargar/libro-electronico/libro-mayor', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteEntregaARendirxIdSocio = idTrabajadorViatico =>
  axios.get('/asientos-contables/descargar/reporte-entrega-a-rendir', {
    responseType: 'blob',
    params: {
      idTrabajadorViatico
    }
  })

export const descargarReporteEntregaARendirxIdUsuario = idUsuario =>
  axios.get('/asientos-contables/descargar/reporte-entrega-a-rendir', {
    responseType: 'blob',
    params: { idTrabajadorViatico: idUsuario }
  })

export const descargarReporteAnexos = params =>
  axios.get('/asientos-contables/descargar/reporte-anexos', { responseType: 'blob', params: params })

export const descargarReporteFormato1p2 = params =>
  axios.get('/asientos-contables/descargar/reporte-formato1p2', { responseType: 'blob', params: params })

export const descargarReporteFormato1p1 = params =>
  axios.get('/asientos-contables/descargar/reporte-formato1p1', { responseType: 'blob', params: params })

export const descargarReporteLibroAuxiliar = params =>
  axios.get('/asientos-contables/descargar/reporte-formatonuevo', { responseType: 'blob', params: params })

export const obtenerBalancexCuenta = cuentaContable =>
  axios.get(`/asientos-contables/balance`, {
    params: {
      tipoConsulta: 'prefijo-cuenta',
      cuentaContable: cuentaContable
    }
  })

export const descargarReporteEstadosFinancieros = params =>
  axios.get('/asientos-contables/descargar/reporte-estadosFinancieros', { responseType: 'blob', params: params })

export const descargarReporteVerificacionAsientosComprasVentas = params =>
  axios.get('/asientos-contables/descargar/reporte-verificacion-asientos-compras-ventas', {
    responseType: 'blob',
    params: params
  })

export const descargarReporteExcelDetracciones = () =>
  axios.get('/asientos-contables/descargar/excel-detracciones', { responseType: 'blob' })

export const descargarReporteTxtDetracciones = ({ flagGenerarNuevoCorrelativo }) =>
  axios.get('/asientos-contables/descargar/txt-detracciones', {
    responseType: 'blob',
    params: { flagGenerarNuevoCorrelativo }
  })

export const descargarBalancePleAnual = params =>
  axios.get('/asientos-contables/descargar/ple-balance-anual', { responseType: 'blob', params: params })

export const descargarRelacionAsientosCentros = params =>
  axios.get('/asientos-contables/descargar/reporte-relacion-asientos-centros', { responseType: 'blob', params: params })

export const descargarReporteRegistroProveedores = params =>
  axios.get('/asientos-contables/descargar/registro-proveedores', { responseType: 'blob', params: params })

export const descargarReporteCuadreCuentas206090 = params =>
  axios.get('/asientos-contables/descargar/reporte-cuentas-206090', { responseType: 'blob', params: params })

export const descargarReporteCuadreCuentas60Digitadas = params =>
  axios.get('/asientos-contables/descargar/reporte-cuentas-60-digitadas', { responseType: 'blob', params: params })

export const descargarReporteCuadreCuentas90Digitadas = params =>
  axios.get('/asientos-contables/descargar/reporte-cuentas-90-digitadas', { responseType: 'blob', params: params })

export const descargarReporteAsientosDescuadrados = data =>
  axios.get('/asientos-contables/descargar/reporte-asientos-descuadrados', { params: data, responseType: 'blob' })

export const descargarReporteAsientosSinCC = () =>
  axios.get('/asientos-contables/descargar/reporte-asientos-centrocosto', { responseType: 'blob' })

export const generarDeInventarios = flagReporte =>
  axios.post('/asientos-contables/generar-de-inventarios', { flagReporte }, { responseType: 'blob' })

export const cambiarCuenta = data => axios.post('/asientos-contables/cambiar-cuenta', data)

export const recalcularTcComprasVentas = idsDetalles =>
  axios.post('/asientos-contables/recalculartc-asientos-compras-ventas', { idsDetalles })

export const mayorizarxFiltros = data => axios.post('/asientos-contables/mayorizar', data, { responseType: 'blob' })

export const generarAsientosCierre = () => axios.post('/asientos-contables/generar-asientos-cierre')

export const generarAsientosCierreActivoPasivoPatrimonio = () =>
  axios.post('/asientos-contables/generar-asientos-cierre-activo-pasivo-patrimonio')

export const generarAsientoAperturaEnBaseACierreAnoAnterior = () =>
  axios.post('/asientos-contables/generar-asientos-apertura-en-base-cierre-ano-anterior')

export const validarSaldoCeroClases6789 = () => axios.post('/asientos-contables/validar-saldo-cero-clases6789')

export const validarSaldoCeroClases12345 = () => axios.post('/asientos-contables/validar-saldo-cero-clases12345')

export const validarAsientoAperturaNumeroOperacion1 = () =>
  axios.post('/asientos-contables/validar-asientos-apertura-1')

export const actualizarEstadoEnvioxId = (id, data) => axios.put(`/asientos-contables/${id}/estado-envio`, data)

export const actualizarMasivoEstadoEnvioxIds = data => axios.put(`/asientos-contables/estado-envio/masivo`, data)

export const actualizarDetallexIdAsCentroCosto = (id, data) =>
  axios.put(`/asientos-contables/detalles/${id}/centro-costo`, data)

export const actualizarDetallexIdAsCuentaContable = (id, data) =>
  axios.put(`/asientos-contables/detalles/${id}/cuenta-contable`, data)

export const actualizarDetallexIdAsCuentaContableDestino = (id, data) =>
  axios.put(`/asientos-contables/detalles/${id}/cuenta-contable-destino`, { cuentaDestino: data })

export const actualizarDetallexIdAsMonedaMonto = (id, data) =>
  axios.put(`/asientos-contables/detalles/${id}/moneda-monto`, data)

export const getResumenEdicion = _id => axios.get(`/asientos-contables/${_id}/resumen`)

export const getDetallesPaginado = (_id, page = 1, pageSize = 50) =>
  axios.get(`/asientos-contables/${_id}/detalles`, {
    params: { page, pageSize }
  })

export const exportarExcelDetalles = _id =>
  axios.get(`/asientos-contables/${_id}/exportar-excel`, { responseType: 'blob' })

export const editarConChangelog = data => axios.post('/asientos-contables/editar-changelog', data)
